import { AmpCommonFiltersState as CommonFiltersState, Exclusivity, FiltersList } from '~/core/config/filters/types'

import IconAlaoSmile from '~/components/icons/IconAlaoSmile.vue'

export const initialState: CommonFiltersState = Object.freeze({
  offer_types: [Exclusivity.EXCLUSIVE, Exclusivity.REGULAR],
  special_offers: [],
})

export const getInitialState = (): CommonFiltersState => JSON.parse(JSON.stringify(initialState))

export const filtersList = (_rootGetters: any): FiltersList => {
  const defaultValues = getInitialState()

  return [
    {
      name: 'offer_types',
      component: 'MultipleSelection',
      props: {
        title: 'offerFilters.plans',
        deselectAll: false,
        defaultValue: defaultValues.offer_types,
        items: [
          {
            name: 'offerFilters.exclusiveAlaoDeals',
            value: Exclusivity.EXCLUSIVE,
            extra: {
              slotAfter: IconAlaoSmile,
            },
          },
          {
            name: 'offerFilters.regularOffers',
            value: Exclusivity.REGULAR,
          },
        ],
      },
    },
    {
      name: 'special_offers', // key in initialState
      component: 'MultipleSelection',
      props: {
        title: 'offerFilters.specialOffers',
        defaultValue: defaultValues.special_offers,
        items: [
          {
            name: 'offerFilters.under30',
            value: 'under_30',
          },
          {
            name: 'offerFilters.withCashback',
            value: 'has_cashback',
          },
          {
            name: 'offerFilters.withVoucher',
            value: 'has_voucher',
          },
        ],
      },
    },
  ]
}
